module.exports = __webpack_public_path__ + "static/media/logout.d41480d0.svg";